<ng-container *ngIf="vm$ | async as vm">
	<div class="mb-5">
		<app-input
			[autofocus]="true"
			placeholder="Search clients or files"
			[(ngModel)]="vm.searchValue"
			(debounce)="search($event)"
			[debounceCharacterLimit]="2"
			[testHook]="testHooks.SearchInput"
		></app-input>
		<div class="rounded-md bg-grey-veryLight text-sm p-2 mt-2">
			<strong>Search hint:</strong> Start your search with
			<strong class="text-lg">'#'</strong> to search only by file number e.g.
			#1234
		</div>
	</div>
	<div
		*ngIf="vm.showHistory"
		[@openClose]
		class="rounded-lg p-1.5"
		style="background-color: var(--scrollable-bg-color)"
	>
		<h3>Recently viewed</h3>
		<div class="flex flex-col gap-1.5" *ngIf="vm.recentlyViewed.length > 0">
			<app-matter-tile
				*ngFor="let matter of vm.recentlyViewed; trackBy: trackByMatter"
				[matter]="matter"
				(click)="goToMatter(matter.id, true)"
				class="hover:cursor-pointer"
				[testHook]="testHooks.RecentMatterTile"
			></app-matter-tile>
		</div>
	</div>

	<div
		*ngIf="vm.searching"
		[@openClose]
		class="flex w-full justify-center items-center"
	>
		<app-icon
			[icon]="ICON.LOADING"
			[spin]="true"
			[testHook]="testHooks.LoadingIcon"
		></app-icon>
		<span class="ml-2">Searching</span>
	</div>

	<ng-container *ngIf="!vm.searching && !vm.showHistory">
		<div
			[@openClose]
			class="rounded-lg p-1.5"
			style="background-color: var(--scrollable-bg-color)"
		>
			<div>
				<h3 class="w-full flex-1">
					Matters
					<span
						class="inline-flex px-2.5 py-0.5 bg-grey-lighter rounded-md justify-center content-center text-sm font-bold"
						>{{ matters?.length }}</span
					>
				</h3>
				<div class="p-1.5 flex flex-col gap-1.5">
					<app-matter-tile
						*ngFor="let matter of matters; trackBy: trackByAlgoliaMatter"
						[matter]="matter"
						(click)="goToMatter(matter.id, false)"
						class="hover:cursor-pointer"
						[testHook]="testHooks.MatterTile"
						><span
							[matTooltip]="matter.closingDate | date"
							class="text-sm"
							[class.text-grey]="matter.closingDate"
							[class.text-grey-light]="!matter.closingDate"
							>{{ matter.closingDate | dateClosedAgo }}</span
						></app-matter-tile
					>
				</div>
			</div>
		</div>
		<div>
			<h3 class="mt-7">
				Clients
				<span
					class="inline-flex px-2.5 py-0.5 bg-grey-lighter rounded-md justify-center content-center text-sm font-bold"
					>{{ clients?.length }}</span
				>
			</h3>
			<div
				*ngFor="let client of clients; trackBy: trackByClient"
				(click)="goToClient(client.objectID)"
				class="result"
				[testHook]="testHooks.GoToClientDiv"
			>
				<div class="font-bold truncate">{{ client | clientName }}</div>
				<div class="flex flex-col">
					<div *ngIf="client?.phone" class="clientLink">
						<app-icon
							[icon]="ICON.PHONE"
							class="mr-2 text-grey-light"
							[testHook]="testHooks.PhoneIcon"
						></app-icon
						><a
							externalNavInterceptor
							href="tel:{{ client.phone }}"
							target="_blank"
							(click)="stopProp($event)"
							[testHook]="testHooks.PhoneLink"
							>{{ client.phone }}</a
						>
					</div>
					<div *ngIf="client?.email" class="clientLink">
						<app-icon
							[icon]="ICON.EMAIL"
							class="mr-2 text-grey-light"
							[testHook]="testHooks.EmailIcon"
						></app-icon
						><a
							emailLinkInterceptor
							[mailto]="client.email"
							(click)="stopProp($event)"
							[testHook]="testHooks.EmailLink"
							>{{ client.email }}</a
						>
					</div>
					<div
						*ngIf="client?.serviceAddess"
						class="truncate text-sm text-grey mt-2"
					>
						<app-icon
							[icon]="ICON.LOCATION"
							class="mr-2 text-grey-light"
							[testHook]="testHooks.LocationIcon"
						></app-icon>
						{{ client?.serviceAddess | address }}
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-container>
